import dynamic from "next/dynamic";
import type { VideoJsPlayerOptions } from "video.js";

import type { Recording } from "@/content-hub/types";

type RecordingPlayerProps = VideoJsPlayerOptions & { recording: Recording };

export const RecordingPlayer = dynamic<RecordingPlayerProps>(
  () => import("./recording-player").then((mod) => mod.RecordingPlayer),
  {
    ssr: false,
  }
);
